import React from 'react';
type StatCardProps = {
  title: string;
  value: string | number;
  icon?: ReactNode;
  trend?: {
    value: number;
    label: string;
  };
  className?: string;
};
export function StatCard({
  title,
  value,
  icon,
  trend,
  className = ''
}: StatCardProps) {
  return <div className={`bg-card rounded-lg border border-border shadow-sm p-5 ${className}`} data-id="element-1675">
      <div className="flex justify-between items-start" data-id="element-1676">
        <div data-id="element-1677">
          <p className="text-sm font-medium text-muted-foreground" data-id="element-1678">{title}</p>
          <p className="mt-2 text-2xl font-semibold text-card-foreground" data-id="element-1679">
            {value}
          </p>
          {trend && <div className="mt-2 flex items-center" data-id="element-1680">
              <span className={`text-sm ${trend.value >= 0 ? 'text-success' : 'text-destructive'}`} data-id="element-1681">
                {trend.value >= 0 ? '+' : ''}
                {trend.value}%
              </span>
              <span className="ml-2 text-xs text-muted-foreground" data-id="element-1682">
                {trend.label}
              </span>
            </div>}
        </div>
        {icon && <div className="p-2 bg-accent rounded-lg" data-id="element-1683">{icon}</div>}
      </div>
    </div>;
}